import { Row, Card, Typography, Col, Avatar, Image } from "antd";
import { getCardStyle } from "../../../utils/getCardStyle";
import { PauseCircleOutlined, PlayCircleOutlined } from "@ant-design/icons";

const { Text } = Typography;

const GranelCard = ({
  id,
  item,
  darkMode,
  ordenActiva,
  setModalVisible,
  // State para play/pause lote/vto
  loteVtoActivo,
  onSetLoteVtoActivo,
  loteVtoActivoRef,
  colorEstado,
}) => {
  const tienePalet = true;

  const esLoteVtoActivo =
    loteVtoActivo &&
    loteVtoActivo.sku === item.sku &&
    loteVtoActivo.nropar === item.nropar &&
    loteVtoActivo.lote === item.lote &&
    loteVtoActivo.vto === item.vto;

  // Color por estado de conteo: cambia según los movimientos del artículo,
  // pero si no hay estado (default del estilo) se mantiene la base #fafafa.
  const baseFondo = getCardStyle(darkMode)?.backgroundColor ?? "#ffffff";
  const colorEstadoFondo =
    colorEstado &&
    colorEstado !== baseFondo &&
    colorEstado !== "#fffffff2"
      ? colorEstado
      : "#fafafa";

  const norm = (v) => (v == null ? "" : String(v).trim());
  const normVto = (v) => norm(v).replaceAll("-", "");

  return (
    <Col
      id={id}
      span={24}
      key={`${norm(item.sku)}|${norm(item.nropar)}|${norm(item.lote)}|${normVto(item.vto)}`}
      style={{ display: "flex", scrollMarginTop: "70px" }}
    >
      <Card
        hoverable
        style={{
          cursor: tienePalet ? "pointer" : "default",
          ...getCardStyle(darkMode),
          backgroundColor: colorEstadoFondo,
          height: "100%",
          flex: 1,
          transition: "background-color 0.2s linear",
        }}
      >
        {/* FILA 1: SKU */}
        <Row justify="space-between" align="top" wrap={false}>
          <Col style={{ minWidth: 0 }}>
            <Text
              strong
              style={{
                fontSize: "20px",
                color: "#000",
                display: "block",
                wordBreak: "break-word",
                overflowWrap: "anywhere",
              }}
            >
              {item.sku || "-"}
              {item?.ctdpar > 1 && item.articuloparte_numeroparte
                ? `-${String(item.articuloparte_numeroparte).padStart(2, "0")}`
                : ""}
            </Text>
          </Col>
        </Row>

        {/* FILA 2: Nombre + Modelo + Avatar */}
        <Row justify="space-between" align="top" wrap style={{ marginTop: 8 }}>
          <Col flex="auto" style={{ minWidth: 0 }}>
            <Text
              style={{
                display: "block",
                color: "#000",
                fontSize: "15px",
                wordBreak: "break-word",
                overflowWrap: "anywhere",
                marginBottom: 4,
              }}
            >
              {item.nombre}
            </Text>

            <Text strong style={{ display: "block", color: "#000" }}>
              {item?.valcar}
            </Text>

            <Text
              style={{
                display: "block",
                color: "#000",
                fontSize: "15px",
                wordBreak: "break-word",
                overflowWrap: "anywhere",
              }}
            >
              {item.modelo}
            </Text>

            <div style={{ marginTop: 8 }}>
              {(item.lote || item.vto) && (
                <div
                  style={{
                    padding: "6px 0",
                  }}
                >
                  <Text style={{ fontSize: 15, color: "black" }}>
                    {item.lote && (
                      <span>
                        <Text style={{ color: "black" }} strong>
                          L:
                        </Text>{" "}
                        {item.lote}
                      </span>
                    )}
                    <span> {" • "} </span>
                    {item.vto && (
                      <span>
                        <Text style={{ color: "black" }} strong>
                          V:
                        </Text>{" "}
                        {item.vto}
                      </span>
                    )}
                  </Text>
                </div>
              )}
            </div>
          </Col>
          <Col flex="none" style={{ marginLeft: "auto" }}>
            <Avatar
              src="/assets/producto.png"
              size={60}
              style={{ backgroundColor: "#8f9ee0" }}
            />
          </Col>
        </Row>

        {/* FILA 3: Ícono del teclado + Cantidad */}
        <Row justify="space-between" align="middle" style={{ marginTop: 12 }}>
          <Col style={{ minWidth: 0 }}>
            <div
              style={{
                display: "flex",
                gap: 8,
                alignItems: "center",
                flexWrap: "wrap", // ← clave para mobile
              }}
            >
              {ordenActiva && Number(item.ctdaud) >= 1 && (
                <Image
                  className="custom-icon"
                  src="/icons/keyboard.png"
                  preview={false}
                  style={{ width: 36, cursor: "pointer" }}
                  onClick={(e) => {
                    e.stopPropagation();
                    // El pin de play/pause solo debe tomarse cuando pertenece al
                    // mismo artículo (sku+nropar): si hay otro artículo activo y
                    // se abre el teclado en este, se usa el lote/vto propio de la
                    // fila; si no, el modal no encuentra la fila y no suma nada.
                    const lotePin = loteVtoActivoRef.current;
                    const mismoArticuloPin =
                      lotePin &&
                      String(lotePin.sku ?? "").trim() ===
                        String(item.sku ?? "").trim() &&
                      (lotePin.nropar ?? "") === (item.nropar ?? "");
                    setModalVisible({
                      status: true,
                      payload: {
                        ...item,
                        sku: item.sku,
                        nombre: item.nombre,
                        parte: item.nropar,
                        modelo: item.modelo,
                        ubicacion: "-",
                        cantidad: item.cantid,
                        valorInicial: item.ctdaud,
                        idartp: item.idartp,
                        nropar: item.nropar,
                        lote: mismoArticuloPin ? lotePin.lote : item.lote,
                        vto: mismoArticuloPin ? lotePin.vto : item.vto,
                      },
                    });
                  }}
                />
              )}

              {ordenActiva && (
                <>
                  {esLoteVtoActivo ? (
                    <PauseCircleOutlined
                      style={{
                        fontSize: 23,
                        color: "#faad14",
                        cursor: "pointer",
                      }}
                      onClick={(e) => {
                        e.stopPropagation();
                        onSetLoteVtoActivo?.(null);
                      }}
                    />
                  ) : (
                    <PlayCircleOutlined
                      style={{
                        fontSize: 23,
                        color: "#52c41a",
                        cursor: "pointer",
                      }}
                      onClick={(e) => {
                        e.stopPropagation();
                        onSetLoteVtoActivo?.({
                          sku: item.sku,
                          nropar: item.nropar,
                          lote: item.lote,
                          vto: item.vto,
                        });
                      }}
                    />
                  )}
                </>
              )}
            </div>
          </Col>
          <Col style={{ minWidth: 0, textAlign: "right" }}>
            <Text
              strong
              style={{
                fontSize: "20px",
                color: "#000",
                wordBreak: "break-word",
                overflowWrap: "anywhere",
              }}
            >
              {Number(item.ctdaud ?? 0)} Unid.
            </Text>
          </Col>
        </Row>
      </Card>
    </Col>
  );
};

export default GranelCard;
